import * as THREE from 'three';

export function createNameLabel(name, color = '#ffffff') {
    // Create canvas for text
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 64;
    const ctx = canvas.getContext('2d');
    
    // NO background - transparent only
    ctx.clearRect(0, 0, 256, 64);
    
    // Text with outline for visibility
    ctx.font = 'bold 32px Courier New';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // Black outline
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.8)';
    ctx.lineWidth = 4;
    ctx.strokeText(name, 128, 32);
    
    // Colored text
    ctx.fillStyle = color;
    ctx.fillText(name, 128, 32);
    
    // Create sprite
    const texture = new THREE.CanvasTexture(canvas);
    const spriteMaterial = new THREE.SpriteMaterial({ 
        map: texture,
        transparent: true,
        depthTest: false,
        depthWrite: false
    });
    const sprite = new THREE.Sprite(spriteMaterial);
    sprite.scale.set(2, 0.5, 1);
    sprite.position.y = 1.5; // Much closer to entity (near health bar)
    sprite.renderOrder = 1000; // Render on top
    
    return sprite;
}
